import { useEffect, useState } from "react";
import { clubApi } from "../api/club.service";
import { ClubHistoryType, PagingType } from "../types";

export const useGetTracking = (
  id: string,
  initialParams?: Record<string, any>
) => {
  const [params, setParams] = useState<Record<string, any>>(
    initialParams || {}
  );
  const [data, setData] = useState<ClubHistoryType[]>([]);
  const [paging, setPaging] = useState<PagingType | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<any>(null);

  const fetchData = async (id: string, fetchParams: Record<string, any>) => {
    try {
      setLoading(true);

      const response: any = await clubApi.getTracking(id, fetchParams);

      setData(response?.data?.data?.data ?? []);
      setPaging(response?.data?.data?.paging ?? null);

      return true;
    } catch (err: any) {
      console.log("Get clubs tracking failed:", err);

      setError(err.message || "Something wrong");

      return false;
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(id, params);
  }, [id, JSON.stringify(params)]);

  return {
    data,
    fetchData,
    paging,
    loading,
    error,
    params,
    setParams,
  };
};
